export interface SolutionsAffairesItem {
  id: number;
  title: string;
  category: string;
  description: string;
  aiSuggestion: string;
  kpiScore: number;
  imageUrl?: string;
  isCompleted?: boolean;
  inKnowledgeBase?: boolean;
  scoreDany?: number;
  scoreYannick?: number;
  scoreFrancois?: number;
  visionDany?: string;
  visionYannick?: string;
  visionFrancois?: string;
}

export const solutionsAffairesData: SolutionsAffairesItem[] = [
  {
    id: 1,
    title: "Cadre Référentiel NIST 2.0",
    category: "Framework",
    description: "Approche holistique de la cybersécurité basée sur le cadre NIST 2.0. Excellence BZ Inc. dans l'implémentation et la gouvernance.",
    aiSuggestion: "Utilisez le cadre NIST 2.0 pour structurer votre posture cybersécurité de manière holistique et complète.",
    kpiScore: 95,
    imageUrl: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "Le cadre NIST 2.0, c'est notre référence absolue. On ne fait pas les choses à moitié. On fait les choses de manière holistique, complète, professionnelle. C'est ça, l'excellence BZ Inc.",
    visionYannick: "Le NIST 2.0 nous positionne comme experts. Nos clients voient qu'on maîtrise les standards internationaux. C'est un différenciateur commercial puissant.",
    visionFrancois: "Techniquement, le NIST 2.0 nous donne une structure claire pour évaluer, documenter et améliorer la posture cybersécurité. C'est notre méthodologie de référence."
  },
  {
    id: 2,
    title: "CyberOps - Outil de Posture Cybersécurité",
    category: "Outil Interne",
    description: "Notre outil propriétaire développé à l'interne pour visualiser, documenter et analyser la posture cybersécurité de nos clients avec des graphiques avancés.",
    aiSuggestion: "CyberOps transforme les données cybersécurité en visualisations claires et actionnables pour vos clients.",
    kpiScore: 92,
    imageUrl: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "CyberOps, c'est notre fierté. On a développé ça en interne parce qu'on avait besoin d'un outil qui montre vraiment la posture cybersécurité. Les graphiques spider, les visualisations, tout ça permet à nos clients de voir clairement où ils en sont.",
    visionYannick: "CyberOps est un outil de vente puissant. On montre aux clients leur posture en temps réel. C'est visuel, c'est clair, c'est professionnel. Ça fait toute la différence.",
    visionFrancois: "Techniquement, CyberOps intègre toutes nos sources de données cybersécurité. Office 365, Microsoft 365, les outils de sécurité. Tout est centralisé et visualisé de manière cohérente."
  },
  {
    id: 3,
    title: "Microsoft 365 & Office 365 - Posture Sécuritaire",
    category: "Plateforme",
    description: "Analyse approfondie de la posture sécuritaire Microsoft 365 (Premium/E5). Évaluation complète des configurations, conformité et protection.",
    aiSuggestion: "Évaluez la posture sécuritaire complète de votre environnement Microsoft 365 pour optimiser la protection et la conformité.",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1633356122544-1341345f3c21?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Microsoft 365, c'est l'environnement de travail moderne. Mais la sécurité, c'est pas automatique. On doit configurer, monitorer, optimiser. C'est là qu'on excelle.",
    visionYannick: "La plupart de nos clients sont sur Office 365 ou Microsoft 365. Montrer leur posture sécuritaire, c'est montrer qu'on comprend leur environnement. C'est rassurant.",
    visionFrancois: "Techniquement, Microsoft 365 offre une tonne d'outils de sécurité. Defender, Compliance, Purview. On doit les configurer correctement et les monitorer. C'est notre expertise."
  },
  {
    id: 4,
    title: "Loi 25 - Conformité Québec",
    category: "Conformité",
    description: "Accompagnement complet pour la conformité à la Loi 25 (Québec). Protection des renseignements personnels et gouvernance des données.",
    aiSuggestion: "Assurez-vous que votre organisation respecte la Loi 25 avec une approche structurée et documentée.",
    kpiScore: 88,
    imageUrl: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 4,
    visionDany: "La Loi 25, c'est la réalité au Québec. On doit protéger les renseignements personnels. C'est pas optionnel. On accompagne nos clients pour qu'ils soient conformes, pas juste sur papier, mais vraiment.",
    visionYannick: "La Loi 25, c'est un enjeu pour tous nos clients québécois. On leur montre qu'on comprend les exigences et qu'on peut les aider. C'est un service essentiel.",
    visionFrancois: "Techniquement, la Loi 25 exige des mesures de protection, de gouvernance, de documentation. On doit s'assurer que tout est en place et documenté correctement."
  },
  {
    id: 5,
    title: "Prise en Charge Cybersécurité",
    category: "Service",
    description: "Service complet de prise en charge cybersécurité. Évaluation initiale, planification, implémentation et suivi continu.",
    aiSuggestion: "Démarrez votre parcours cybersécurité avec une prise en charge complète et structurée.",
    kpiScore: 87,
    imageUrl: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "La prise en charge, c'est le début de tout. On doit comprendre où le client en est, où il veut aller, et comment on va l'y amener. C'est notre méthodologie PRIsME appliquée à la cybersécurité.",
    visionYannick: "Une bonne prise en charge, c'est rassurant pour le client. Il voit qu'on comprend ses enjeux, qu'on a un plan, qu'on va l'accompagner. C'est la base de la confiance.",
    visionFrancois: "Techniquement, la prise en charge doit être complète. On évalue tout: infrastructure, configurations, processus, conformité. Rien ne doit être laissé au hasard."
  },
  {
    id: 6,
    title: "Évaluation de Posture Cybersécurité",
    category: "Diagnostic",
    description: "Évaluation complète de la posture cybersécurité avec visualisations avancées (spider charts, graphiques). Identification des forces et faiblesses.",
    aiSuggestion: "Obtenez une évaluation complète de votre posture cybersécurité avec des visualisations claires et actionnables.",
    kpiScore: 91,
    imageUrl: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "L'évaluation de posture, c'est la base. On doit voir clairement où le client en est. Les graphiques spider, les visualisations, tout ça permet de communiquer efficacement. C'est visuel, c'est clair, c'est professionnel.",
    visionYannick: "Une bonne évaluation de posture, c'est un outil de vente. On montre au client où il en est, où il devrait être, et comment on va l'y amener. C'est concret, c'est rassurant.",
    visionFrancois: "Techniquement, l'évaluation doit être complète et basée sur des standards reconnus. NIST 2.0, ISO 27001, etc. On doit documenter tout ça de manière professionnelle."
  },
  {
    id: 11,
    title: "Analyses Maester Microsoft 365",
    category: "Diagnostic",
    description: "Portail PRIsME pour connecter l’app Entra ID BZ aux tenants Microsoft 365 des clients, planifier un scan complet Maester et centraliser les résultats passed/failed, détails et remédiations.",
    aiSuggestion: "Centralisez les analyses Maester par client pour suivre les écarts Microsoft 365, conserver l’historique et préparer les remédiations sans multiplier les fichiers locaux.",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1633356122544-1341345f3c21?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: false,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Maester doit devenir un outil récurrent simple: un client, un tenant connecté, un scan complet et des résultats compréhensibles.",
    visionYannick: "Une vue Maester centralisée dans PRIsME aide à démontrer rapidement les écarts Microsoft 365 et les actions à prioriser.",
    visionFrancois: "Techniquement, l’intégration doit isoler les secrets Entra ID côté serveur, standardiser le consentement multi-tenant et stocker les résultats pour suivi historique."
  },
  {
    id: 7,
    title: "Gouvernance Cybersécurité",
    category: "Gouvernance",
    description: "Mise en place d'une gouvernance cybersécurité robuste. Politiques, procédures, comités et responsabilités clairement définies.",
    aiSuggestion: "Structurez votre gouvernance cybersécurité pour assurer une protection efficace et continue.",
    kpiScore: 89,
    imageUrl: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80",
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 4,
    visionDany: "La gouvernance, c'est la fondation. Sans bonne gouvernance, la cybersécurité c'est du bricolage. On doit structurer, documenter, responsabiliser. C'est notre approche holistique.",
    visionYannick: "Une bonne gouvernance cybersécurité, c'est rassurant pour les clients. Ils voient qu'on prend ça au sérieux, qu'on a des processus, qu'on est organisés. C'est professionnel.",
    visionFrancois: "Techniquement, la gouvernance doit couvrir tous les aspects: politiques, procédures, rôles, responsabilités, comités. Tout doit être documenté et clair."
  },
  {
    id: 8,
    title: "Formation & Sensibilisation Cybersécurité",
    category: "Formation",
    description: "Programmes de formation et sensibilisation cybersécurité pour les équipes. Réduction des risques humains et renforcement de la culture sécuritaire.",
    aiSuggestion: "Développez une culture cybersécurité forte dans votre organisation avec des programmes de formation adaptés.",
    kpiScore: 85,
    imageUrl: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 3,
    visionDany: "La formation, c'est essentiel. La meilleure technologie du monde ne sert à rien si les gens ne comprennent pas les risques. On doit former, sensibiliser, répéter. C'est continu.",
    visionYannick: "La formation cybersécurité, c'est un service qu'on peut offrir à nos clients. Ça montre qu'on pense à tout, pas juste la technique. C'est complet.",
    visionFrancois: "Techniquement, la formation doit être adaptée aux rôles, aux risques, aux besoins. On doit documenter qui a été formé, sur quoi, quand. C'est important pour la conformité."
  },
  {
    id: 10,
    title: "Automatisation des suivis uSecure",
    category: "Formation",
    description: "Section prévue pour connecter PRIsME à l’API uSecure et automatiser les suivis mensuels: clients, plans, utilisation, apprenants, formations, campagnes uPhish, expositions uBreach, brouillons de courriels et satisfaction. uPolicy est exclu de PRIsME.",
    aiSuggestion: "Centralisez les données uSecure pour générer un bref résumé de performance par client, repérer les relances à faire et préparer un courriel mensuel de suivi/satisfaction.",
    kpiScore: 86,
    imageUrl: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: false,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Le suivi uSecure doit rendre visible le facteur humain dans son ensemble: formation, simulations, expositions, progression et relances à faire.",
    visionYannick: "Une vue claire des suivis uSecure aide à démontrer la valeur mensuelle de la sensibilisation et à garder les clients engagés.",
    visionFrancois: "Techniquement, l’intégration doit passer par l’API uSecure, synchroniser les clients, plans, apprenants, formations, campagnes uPhish et expositions uBreach, tout en excluant uPolicy de PRIsME."
  },
  {
    id: 9,
    title: "Gestion des rapports d'incident",
    category: "Outil Interne",
    description: "Récupérer les formulaires de rapport d'incident/évènement remplis dans Servo2 (CyberOps) via l'API apibzprisme, puis générer un rapport d'incident cyber et l'enregistrer dans la Gestion documentaire.",
    aiSuggestion: "Sélectionnez un client PRIsME pour lister les formulaires Servo2, choisissez un formulaire et générez le rapport qui sera disponible dans Livrables créés → Documents.",
    kpiScore: 88,
    imageUrl: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: false,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "Les rapports d'incident cyber doivent refléter exactement ce qui a été saisi dans Servo2. Une seule source de vérité, une traçabilité complète.",
    visionYannick: "La gestion des rapports cyber relie Servo2 et PRIsME pour une visibilité documentaire centralisée.",
    visionFrancois: "L'API apibzprisme permet de récupérer les formulaires par nom de client et d'alimenter la Gestion documentaire."
  },
  {
    id: 12,
    title: "Tableau de bord conseiller",
    category: "Outil Interne",
    description: "Vue de pilotage pour prioriser le travail quotidien du conseiller: actions à traiter, clients à relancer, briefings à préparer et documents à produire.",
    aiSuggestion: "Commencez la journée par les priorités conseiller avant de générer des documents: relances, risques, briefings et livrables prêts.",
    kpiScore: 89,
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: false,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Le conseiller doit savoir rapidement quoi traiter aujourd'hui, sans chercher dans plusieurs modules.",
    visionYannick: "Un tableau de bord conseiller donne une vue simple des suivis, risques et documents à préparer avant les rencontres client.",
    visionFrancois: "Techniquement, ce bloc pourra agréger uSecure, projets, offres et documents sans modifier les outils existants."
  },
  {
    id: 13,
    title: "Rapports de balayage",
    category: "Outil Interne",
    description: "Importer les résultats de balayage de vulnérabilités, enrichir les actifs avec un TXT FortiGate ou l’inventaire client, valider les recommandations et générer un rapport BZ dans la Gestion documentaire.",
    aiSuggestion: "Créez un rapport de balayage à partir du CSV Carson & Saint, validez les actifs détectés et préparez le document client lié au projet, à la tâche et au livrable.",
    kpiScore: 87,
    imageUrl: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: false,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Les rapports de balayage doivent être rapides à produire, mais jamais automatiques au point de perdre la validation humaine sur les actifs et correctifs.",
    visionYannick: "Une génération structurée donne un livrable plus uniforme et facilite la remise client après un balayage de vulnérabilités.",
    visionFrancois: "Techniquement, PRIsME doit séparer les sources: CSV pour les vulnérabilités, FortiGate pour l’enrichissement, inventaire validé comme source finale des actifs."
  },
  {
    id: 14,
    title: "Rapports de campagnes d’hameçonnage",
    category: "Outil Interne",
    description: "Produire, gérer et conserver les rapports de campagnes uSecure/uPhish complétées: gabarit Word, captures du sender, du lien et du courriel envoyé, Excel de résultats, validation des indicateurs et rattachement facultatif à une tâche de projet existante.",
    aiSuggestion: "Importez l’Excel de résultats uSecure, ajoutez les captures requises, validez les statistiques et générez un rapport Word sans créer de projet automatiquement.",
    kpiScore: 86,
    imageUrl: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: false,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Le rapport d’hameçonnage doit être simple: on part de la campagne uSecure terminée, on joint les preuves visuelles et on génère un livrable propre.",
    visionYannick: "Un rapport uniforme facilite la remise client et montre clairement les résultats de sensibilisation sans créer de projet inutile.",
    visionFrancois: "Techniquement, PRIsME doit lire l’Excel uSecure, générer le DOCX, conserver l’historique et rattacher le rapport à une tâche existante lorsque requis."
  }
];












